import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAsyncEffect } from 'customHooks/hooks';
import { SelectedDateRange } from 'types/misc';
import { fetchTotalSubmissionsBySurveyGroup } from 'services/surveyGroup';
import { ZCDIcon, ZCDIconColor, ZCDSpinner } from '@zencity/common-ui';
import { Flex } from 'components/Flex/Flex';
import { config } from '../../../../../../../config/config';
import styles from './CardHeader.module.scss';

interface Props {
  surveyGroupId: number;
  selectedDateRange: SelectedDateRange;
  divisionId?: number;
}

export const CardHeader = (props: Props): ReactElement => {
  const { surveyGroupId, selectedDateRange, divisionId } = props;
  const { t: translate } = useTranslation();

  const blockwiseUrl = `${config.insights.domain}${config.blockwise.baseUrl}`;

  const fetchSurveyGroupTotalSubmissions = async () => {
    const response = await fetchTotalSubmissionsBySurveyGroup({
      surveyGroupId,
      startDate: selectedDateRange.startDate,
      endDate: selectedDateRange.endDate,
      divisionId,
    });
    return response;
  };

  const { fetchedData: totalSubmissions, isLoading } = useAsyncEffect(fetchSurveyGroupTotalSubmissions, [
    surveyGroupId,
    selectedDateRange,
    divisionId,
  ]);

  if (isLoading) {
    return <ZCDSpinner />;
  }

  return (
    <Flex justifyContent="space-between">
      <div>
        <h3 className={styles.title}>{translate('widgetGenerator.widgets.scoresOverTimeByArea.name')}</h3>
        <p className={styles.totalSubmissions}>
          {translate('widgetGenerator.widgets.scoresOverTimeByArea.totalSubmissions', {
            totalSubmissions: totalSubmissions?.total_valid_submissions ?? 0,
          })}
        </p>
      </div>
      <a className={styles.resultsLink} href={blockwiseUrl} target="_blank" rel="noreferrer">
        {translate('widgetGenerator.widgets.scoresOverTimeByArea.exploreResults')}
        <ZCDIcon name="external-link" color={ZCDIconColor.BLUE} />
      </a>
    </Flex>
  );
};
